import api from './api';

/**
 * @param {string} testId
 * @param {string} levelId
 * @param {{
 *  name: string
 *  qpvSet: string
 *  test_ids: string[]
 *  tf_thresholds: { tf_id: string, threshold: number }[]
 *  test_threshold: { test_id: string, shields: number[] }[]
 * }} body
 * @returns {Promise<{
 *  test_group_id: string
 *  name: string
 *  qpvSet: string
 *  status: string
 *  tests: {
 *      test_id: string
 *      skill_id: string
 *      test_threshold: null | {
 *          test_threshold_id: string
 *          shield_1: number
 *          shield_2: number
 *          shield_3: number
 *          shield_4: number
 *          shield_5: number
 *      }
 *  }[]
 *  test_focuses_thresholds: {
 *      tf_threshold_id: string
 *      threshold: number
 *      test_focuses: {
 *          tf_id: string
 *          tag: string
 *          name: string
 *          qpvSet: string
 *          strengths_in_english: string
 *          here_are_some_things: string
 *          what_can_i_do: string
 *      }
 *  }[]
 * }>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-TestGroups-putTestGroup
 */
export default async function updateTest(testId, levelId, body) {
    const { data } = await api.put(
        `levels/${levelId}/test_groups/${testId}`,
        body
    );

    return data;
}